import { create } from "zustand";
import { api } from "~/lib/api";
import type { Account } from "~/types";

interface AccountState {
  account: Account | null;
  loaded: boolean;
  loading: boolean;
  load: () => Promise<void>;
}

export const useAccountStore = create<AccountState>((set, get) => ({
  account: null,
  loaded: false,
  loading: false,
  load: async () => {
    if (get().loaded || get().loading) return;
    set({ loading: true });
    const account = await api.account();
    set({ account, loaded: true, loading: false });
  },
}));
